export const categoryHeaders = {
    CATEGORY_NAME : 'Category Name',
    REJECTION_REASON : 'Rejection Reason :',
    APPROVAL_REASON : 'Approval comment :'
}